import useAsync from 'react-use/esm/useAsync';
import { Entity } from '@backstage/catalog-model';

/** @public */
export const CLOUDBUILD_ANNOTATION = 'google.com/cloudbuild-project-slug';

export const useProjectName = (entity: Entity) => {
  const { value, loading, error } = useAsync(async () => {
    return entity?.metadata.annotations?.[CLOUDBUILD_ANNOTATION] ?? '';
  });
  return { value, loading, error };
};
